import { ShippingVariantSelector } from '../../../../../../ShippingVariantSelector'
import { SettingsProps } from '../../../hooks/useGenericComponent'

export function FreeShippingEditor(props: SettingsProps) {
  const { state } = props

  return <ShippingVariantSelector state={state} />
}
